var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#device_svg__clip0_1124_1429)",
    fill: "#3A92E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.049 0H1.95A1.946 1.946 0 000 1.951v19.183a1.946 1.946 0 001.951 1.951h9.098A1.947 1.947 0 0013 21.134V1.95A1.977 1.977 0 0011.049 0zM1.95.752h9.098a1.204 1.204 0 011.199 1.2v1.08H.728v-1.08a1.208 1.208 0 011.223-1.2zm10.297 3.033v15.28H.728V3.785h11.52zm-1.2 18.571H1.952a1.203 1.203 0 01-1.199-1.199v-1.34h11.52v1.34a1.258 1.258 0 01-1.223 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.487 21.816a.776.776 0 100-1.552.776.776 0 000 1.552z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.463 21.816a.776.776 0 100-1.552.776.776 0 000 1.552zM5.056 1.67a.306.306 0 100 .61h2.797a.31.31 0 00.22-.524.296.296 0 00-.22-.087H5.056z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "device_svg__clip0_1124_1429"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v23.085H0z"
  })))));
}
export default SvgDevice;